//-------------------------------------------------------------------------------------------------- Imports
import { PayloadAction, createSlice } from "@reduxjs/toolkit";



//-------------------------------------------------------------------------------------------------- Interfaces
interface BloquedDialogSliceInterface {
    show: boolean;
    serviceType: string;
    onFinalize: Function | undefined;
};



//-------------------------------------------------------------------------------------------------- Vars and consts
const bloquedDialogSliceInitialState = {
    show: false,
    serviceType: "",
    onFinalize: undefined
} as BloquedDialogSliceInterface;



//-------------------------------------------------------------------------------------------------- Slice
const bloquedDialogSlice = createSlice({
    name: "bloquedDialog",
    initialState: bloquedDialogSliceInitialState,
    reducers: {
        setBloquedDialog: (state, action: PayloadAction<BloquedDialogSliceInterface>) => {
            state.show = action.payload.show;
            state.serviceType = action.payload.serviceType;
            state.onFinalize = () => {(action.payload.onFinalize) && action.payload.onFinalize()};
        },
        showBloquedDialog: (state, action: PayloadAction<boolean>) => {
            state.show = action.payload;
        },
        clearBloquedDialog: (state) => {
            state.show = bloquedDialogSliceInitialState.show;
            state.serviceType = bloquedDialogSliceInitialState.serviceType;
            state.onFinalize = bloquedDialogSliceInitialState.onFinalize;
        }
    }
});



//-------------------------------------------------------------------------------------------------- Exports
export const {setBloquedDialog, showBloquedDialog, clearBloquedDialog} = bloquedDialogSlice.actions;
export const getBloquedDialogData = (state: any) => (
    state.bloquedDialog
) as BloquedDialogSliceInterface;
export default bloquedDialogSlice.reducer;
